<template>
  <div class="serial-code-create">
    <div class="dialog-content">
      <div class="mb-x2" layout layout-align="space-between-start">
        <el-button type="default" @click="changeTab('serial-code-table')"
          ><i class="mdi mdi-keyboard-backspace"></i>戻る</el-button
        >
      </div>
      <div class="message message-error mb-x2">
        使用済みのシリアルコードの割り当てを一括解除してよろしいですか?<br />この操作は取り消しできません。
      </div>
    </div>
    <div class="dialog-footer" slot="footer">
      <div layout layout-align="space-between-start">
        <div></div>
        <el-button type="primary" @click="resetsSerialCode"
          ><i class="mdi mdi-playlist-play"></i>一括解除を実行</el-button
        >
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { mapActions, mapState } from 'pinia'
import { defineComponent } from 'vue'

import api from '@/client/core/api'
import { useTwitterInstantwinMessageStore } from '@/client/store/useTwitterInstantwinMessageStore'
import { useTwitterInstantwinSerialCodeStore } from '@/client/store/useTwitterInstantwinSerialCodeStore'

export default defineComponent({
  data() {
    return {
      isSubmit: false
    }
  },
  computed: {
    ...mapState(useTwitterInstantwinSerialCodeStore, {
      campaignId: state => state.campaignId
    })
  },
  methods: {
    ...mapActions(useTwitterInstantwinSerialCodeStore, ['fetchSerialCodeList']),
    ...mapActions(useTwitterInstantwinMessageStore, ['fetchInstantwinMessages']),

    /**
     * Change screen
     * @param {string} tab
     */
    changeTab(tab: string) {
      this.$emit('change_tab', tab)
    },

    /**
     * Resets serial code
     */
    resetsSerialCode() {
      if (this.isSubmit) return
      this.postButton({
        campaignId: this.campaignId
      })
    },

    /**
     * 使用済みシリアルコードの一括解除
     * @param {Object} params 送信データ
     */
    async postButton(params: any) {
      this.isSubmit = true

      const response = await api.post(`/twitter_instantwin_serial_codes/used_resets`, params)

      setTimeout(() => {
        this.isSubmit = false
      }, 2000)

      if (response.data) {
        const title = '使用済みのシリアルコードの割り当てを一括解除しました。'

        this.$notify({
          title,
          message: '',
          customClass: 'success',
          duration: 5000
        })

        this.changeTab('serial-code-table')
        await this.fetchInstantwinMessages()
        return
      }

      this.$notify({
        title: '使用済みのシリアルコードの割り当て解除に失敗しました。',
        message: '恐れ入りますが、時間をおいて再度お試しください。',
        customClass: 'danger',
        duration: 5000
      })
    }
  }
})
</script>
